import React from "react";

export function GradientIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.53 6.5C13.53 8.43 11.96 10 10.03 10C8.1 10 6.53 8.43 6.53 6.5C6.53 4.57 8.1 3 10.03 3C11.96 3 13.53 4.57 13.53 6.5ZM11.53 6.5C11.53 5.67 10.86 5 10.03 5C9.21 5 8.53 5.67 8.53 6.5C8.53 7.33 9.2 8 10.03 8C10.86 8 11.53 7.33 11.53 6.5Z"
        fill="url(#paint0_linear_14191_10213)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10ZM18 10C18 5.59 14.41 2 10 2C5.58 2 2 5.59 2 10C2 11.13 2.24 12.2 2.66 13.18C3.45 11.88 4.87 11 6.5 11H13.5C15.14 11 16.55 11.88 17.33 13.19C17.76 12.21 18 11.13 18 10ZM4.02 15.3C5.49 16.95 7.62 18 10 18C12.37 18 14.51 16.95 15.98 15.3C15.87 14.01 14.81 13 13.5 13H6.5C5.19 13 4.13 14.02 4.02 15.3Z"
        fill="url(#paint1_linear_14191_10213)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_14191_10213"
          x1="5.41683"
          y1="7.08336"
          x2="10.4168"
          y2="14.5835"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0015FF" />
          <stop offset="1" stopColor="#009EFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_14191_10213"
          x1="5.41683"
          y1="7.08336"
          x2="10.4168"
          y2="14.5835"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0015FF" />
          <stop offset="1" stopColor="#009EFF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
